import React, { useEffect, useState } from 'react'
import { Col, Row, Card, Button } from '@themesberg/react-bootstrap'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { CKEditor } from '@ckeditor/ckeditor5-react'

import { useCookies } from 'react-cookie'

import { getPrivacy, updatePrivacy } from '../../../../controller/api/common'

export const PrivacyEditor = () => {
  const [privacy, setPrivacy] = useState("")
  const [cookies] = useCookies(['lottmekong'])

  useEffect(() => {
    const getPrivacyFunc = async () => {
      const _privacy = await getPrivacy(cookies.lottmekong)

      if (_privacy && _privacy.data) {
        setPrivacy(_privacy.data.content || "")
      }
    }
    getPrivacyFunc()
  }, [cookies.lottmekong])

  const onUpdatePress = async () => {
    try {
      const resp = await updatePrivacy(cookies.lottmekong, privacy)
      if (resp) {
        window.location.reload()
      } else {
        alert('Có lỗi xảy ra')
        return false
      }
    } catch (e) {
      alert('error')
    }
  }

  return (
    <Card border="light" className="shadow-sm">
      <Card.Header>
        <Row className="align-items-center">
          <Col>
            <h5>Điều khoản sử dụng</h5>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <CKEditor
          editor={ClassicEditor}
          config={{
            fontFamily: {
              options: [
                'default',
                'Ubuntu, Arial, sans-serif',
                'Ubuntu Mono, Courier New, Courier, monospace'
              ]
            },
            toolbar: ['bold', 'italic', 'heading', 'bulletedList', 'numberedList', 'fontFamily', 'undo', 'redo']
          }}
          data={privacy}
          onChange={(event, editor) => {
            const data = editor.getData()
            setPrivacy(data)
          }}
        />
      </Card.Body>
      <Card.Footer>
        <Button onClick={onUpdatePress}>Lưu</Button>
      </Card.Footer>
    </Card>
  )
}
